export default __webpack_public_path__ + "static/media/restartIcon.d93879bd.svg";